import { trackEvent } from '@patrianna/analytics'
import type { Currency } from '@patrianna/shared-patrianna-types/store/CurrenciesModule'
import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'

import type { SupportedCurrencies } from 'types/currencies'

import type { CurrenciesState } from './types'

const initialState: CurrenciesState = {
  allCurrencies: [],
  activeCurrencyId: 'GC',
  activeModalCurrencyId: null,
}

export const currenciesSlice = createSlice({
  name: 'currencies',
  initialState,
  reducers: {
    initCurrencies: (state, action: PayloadAction<{ currencies: Array<Currency> }>) => {
      state.allCurrencies = action.payload.currencies.map((el) => ({ ...el }))
    },
    setActiveCurrency: (state, action: PayloadAction<{ activeCurrencyId: SupportedCurrencies }>) => {
      trackEvent(
        'switch_currency',
        { category: 'switch currency', label: action.payload.activeCurrencyId },
        { bloomreach: false },
      )
      state.activeCurrencyId = action.payload.activeCurrencyId
    },

    setDefaultActiveCurrency: (state, action: PayloadAction<{ activeCurrencyId: SupportedCurrencies }>) => {
      state.activeCurrencyId = action.payload.activeCurrencyId
    },

    // @TODO create middleware for this action
    toggleActiveCurrency: (state) => {
      state.activeCurrencyId = state.activeCurrencyId === 'GC' ? 'SC' : 'GC'
    },

    setActiveModalCurrency: (state, action: PayloadAction<{ currencyId: SupportedCurrencies }>) => {
      state.activeModalCurrencyId = action.payload.currencyId
    },

    updateCurrenciesBalance: (state, action: PayloadAction<{ currency: Array<Currency> }>) => {
      state.allCurrencies = state.allCurrencies.map((currency) => {
        const updatedCurrency = action.payload.currency.find((i) => i.currency === currency.currency)

        return updatedCurrency || currency
      })
    },
    clearCurrency: () => initialState,
  },
})

export type ActionsTypes = ReturnType<InferValueTypes<typeof currenciesSlice.actions>>
export const { actions } = currenciesSlice
